import { publicApiClient } from '@/shared/lib/api-client';
import type { AuthResponse, AuthUser } from '@bookclub/shared';

export async function loginWithTelegram(initData: string): Promise<AuthResponse> {
  return publicApiClient
    .post('auth/telegram-webapp', { json: { initData } })
    .json<AuthResponse>();
}

export interface WebOtpVerifyResponse extends AuthResponse {
  supabaseAccessToken: string;
}

export async function requestWebEmailOtp(email: string): Promise<void> {
  await publicApiClient.post('auth/web/otp/request', { json: { email } });
}

export async function verifyWebEmailOtp(email: string, token: string): Promise<WebOtpVerifyResponse> {
  return publicApiClient
    .post('auth/web/otp/verify', { json: { email, token } })
    .json<WebOtpVerifyResponse>();
}

export async function restoreWebAppSession(accessToken: string): Promise<AuthUser> {
  return publicApiClient
    .get('me', {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    })
    .json<AuthUser>();
}
